export const CHANGE_ACTIVE_NAV = "CHANGE_ACTIVE_NAV";
export const CHANGE_ACTIVE_SCHOOL = "CHANGE_ACTIVE_SCHOOL";
export const REHYDRATE_NAV_DATA = "REHYDRATE_NAV_DATA";
